import React from 'react';
import ReactDOM from 'react-dom';
import './indexWithoutVariables.scss';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(
        <App />
, document.getElementById('ambitasContainer'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js